import React, { useState } from 'react'
import Mainlayout from '../layout/Mainlayout'
import { useSelector } from 'react-redux'
import Games from '../data/games.json'
import { GrClose } from "react-icons/gr";
import Addresult from '../components/Addresult'
import { Link } from 'react-router-dom';
import { ImGift } from "react-icons/im";
import { BsCollection } from "react-icons/bs";
import { FaUsers } from "react-icons/fa";
import { TbTallymarks } from "react-icons/tb";
import Add16games from '../components/Add16games';

export default function AdminProfile() {
    const user = useSelector((state) => state.user)

    const current = new Date();
    const yesterday = `${current.getDate() - 1}/${current.getMonth() + 1}/${current.getFullYear()}`;
    const today = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;

    const [section, setSection] = useState(1);
    const [close, setClose] = useState(null)
    const [peshbini, setPeshbini] = useState(null)
    function CLOSE() {
        setClose(
            <div className='md:right-14 fixed md:top-10 top-4 right-4 z-50'>
                <button onClick={() => {
                    setPeshbini(null); setClose(null);
                }}>
                    <GrClose className='w-10 h-10  mx-auto p-1 rounded-full bg-red-300' />
                </button>
            </div>
        )
    }

    const addresult = () => {
        return (
            <div className='container flex flex-col md:flex-row flex-wrap'>

                {Games.map((team, index) => {
                    return (
                        <>
                            {team.date === today || team.date === yesterday ? (
                                <>

                                    <div className='flex flex-col my-3 items-center md:items-end border-2 text-xs bg-yakam rounded-lg w-full md:w-2/5  p-1 md:p-3 mx-auto'>
                                        <div className=' mx-auto text-chwaram'>

                                            <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                            <h1 className=' text-center'>{team.group}</h1>
                                            <div className='flex flex-row space-x-4 my-2 mx-auto'>

                                                <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-md text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                                <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>{team.result}</div>
                                                <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-md text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                            </div>
                                            <div className=' text-center'>

                                                <button onClick={() => {
                                                    setPeshbini(<Addresult index={index} />); CLOSE();
                                                }} className="font-medium text-c7  hover:text-chwaram"> ئەنجام بنووسە</button>

                                                
                                            </div>


                                        </div>
                                    </div>

                                </>
                            )
                                :
                                (
                                    null
                                )}
                        </>
                    )
                })}
            </div>
        )
    }


    const navigation = [
        { name: "زیادکردنی ئەنجامەکان", num: 1 },
        { name: "زیادکردنی یاری قۆناغی ١٦", num: 2 },
        { name: "زیادکردنی یاری قۆناغی ٨", num: 3 },
        { name: "زیادکردنی یاری قۆناغی ٤", num: 4 },
        { name: "زیادکردنی یاری کۆتای", num: 5 }
    ]

    return (
        <Mainlayout>
            <div className='bg-dwam p-3 '>
                {close}
                {peshbini}
                <div className=' container mx-auto justify-center flex flex-col md:flex-row-reverse' >
                    <div className=' bg-yakam md:w-1/5 rounded-t-xl md:rounded-xl space-y-2 ' >

                    <div className=' p-4 bg-yakam w-full rounded-t-xl md:rounded-xl space-y-2 '>
                        <div className='flex flex-row-reverse'>
                            <img className='w-24 h-24 rounded-full' src={user.userImage} alt={user.userImage} />
                        </div>
                        <h1 className='text-right text-xl text-shasham mr-4'>{user.userName}</h1>
                        <p className='text-right text-shasham'> <p className=' text-chwaram'>: ئیمەیڵ</p> {user.userEmail}</p>
                        <p className='text-right text-shasham'> <p className=' text-chwaram'>: ژمارە موبایل</p> 0770 000 0000</p>
                        <p className='text-right text-shasham'> <p className=' text-chwaram'>: ڕۆڵ</p> admin</p>

                        <div className='flex flex-col space-y-2'>

                            {/* <div  className='text-center text-chwaram hover:bg-shasham hover:text-yakam rounded-xl'><Link to='/profile/allusersxal'>هەموو خاڵەکان</Link></div> */}
                            <Link className=' text-center text-chwaram hover:bg-shasham hover:text-yakam rounded-xl flex flex-row items-center justify-center' to='/profile/choosegift'>خەڵاتەکە دیاری بکە &nbsp;<ImGift /> </Link>
                            <Link className=' text-center text-chwaram hover:bg-shasham hover:text-yakam rounded-xl flex flex-row items-center justify-center' to='/profile/allpeshbini'>هەموو پێشبینیەکان&nbsp;<BsCollection /></Link>
                            <p className='cursor-pointer text-center text-chwaram hover:bg-shasham hover:text-yakam rounded-xl flex flex-row items-center justify-center'>هەموو خاڵەکان&nbsp;<TbTallymarks /></p>
                            <Link className=' text-center text-chwaram hover:bg-shasham hover:text-yakam rounded-xl flex flex-row items-center justify-center' to='/profile/allusers'>هەموو یوزەرەکان&nbsp;<FaUsers /></Link>
                        </div>
                    </div>
                    </div>
                    <div className='md:w-4/5 mt-2 md:mt-0 w-full flex-col justify-center '>
                        <div className='w-full md:w-[95%] text-[10px] h-fit md:text-lg items-center flex flex-row bg-yakam '>
                            {navigation.reverse().map((nav) => {
                                return (
                                    <>
                                        <div onClick={() => { setSection(nav.num) }} className='w-1/5 p-3 h-full cursor-pointer item-center text-center hover:bg-seyam hover:text-yakam text-chwaram'><p className=''>{nav.name}</p></div>
                                    </>
                                )
                            })}
                        </div>
                        <div className=' w-full  md:w-[95%]  '>
                            {
                                section === 1 ?
                                    (
                                        addresult()
                                    )
                                    :
                                    section === 2 ?
                                        (
                                            <Add16games />
                                        )
                                        :
                                        section === 3 ?
                                            (
                                                <>coming soon</>
                                            )
                                            :
                                            section === 4 ?
                                                (
                                                    <>coming soon</>
                                                )
                                                :
                                                section === 5 ?
                                                    (
                                                        <>coming soon</>
                                                    )
                                                    :
                                                    (
                                                        null
                                                    )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Mainlayout>
    )
}
